// extracted by mini-css-extract-plugin
export var infoItem = "_or-2";
export var title = "_or-0";
export var value = "_or-1";